import AssessorCard from './AssessorCard';
import ButtonWrapper from '@components/common/ButtonWrapper';
import { AssessorDTO } from '@behavior/activity/dto/AssessorDTO';
import { ActivityInitialDataResponse } from '@components/Activity/types/ActivityInitialDataResponse';

type Props = {
  initialData?: ActivityInitialDataResponse;
  assessorList: AssessorDTO[];
  setAssessorList?: (assessorList: AssessorDTO[]) => void;
  disabled?: boolean;
};

const AssessorContainer = ({ initialData, assessorList, setAssessorList, disabled }: Props) => {

  const addAssessorCard = () => {
    if (setAssessorList) {
      setAssessorList([
        ...assessorList,
        {
          person: undefined,
          signatureDte: undefined,
        },
      ]);
    }
  };

  const removeCard = (index: number) => {
    const updatedCardsList = assessorList.filter((_, i) => index !== i);
    if (setAssessorList) {
      setAssessorList(updatedCardsList);
    }
  };

  const setAssessorCardContent = (index: number, newContent: AssessorDTO) => {
    const updatedAssessorCardData = [...assessorList];
    updatedAssessorCardData[index] = newContent;
    if (setAssessorList) {
      setAssessorList(updatedAssessorCardData);
    }
  };

  return (
    <>
      {!disabled && (
        <div className="activityAddButtonWithMargin">
          <ButtonWrapper
            label="traceability.form.details.page.container.add.assessor"
            primary
            icon="add"
            onClick={addAssessorCard}
          />
        </div>
      )}
      {assessorList?.map((data, index) => (
        <div key={index}>
          <AssessorCard
            initialData={initialData}
            assessorContent={data}
            setAssessorContent={(newContent: AssessorDTO) => {
              setAssessorCardContent(index, newContent);
            }}
            onRemove={() => removeCard(index)}
            disabled={disabled}
            index={index}
          />
        </div>
      ))}
    </>
  );
};

export default AssessorContainer;
